import { render, staticRenderFns } from "./static.vue?vue&type=template&id=7736a6cb&scoped=true"
import script from "./static.vue?vue&type=script&lang=js"
export * from "./static.vue?vue&type=script&lang=js"
import style0 from "./static.vue?vue&type=style&index=0&id=7736a6cb&prod&lang=scss&scoped=true"
import style1 from "./static.vue?vue&type=style&index=1&id=7736a6cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7736a6cb",
  null
  
)

export default component.exports